import { render, staticRenderFns } from "./patientUploadItem.vue?vue&type=template&id=63f359cd&"
import script from "./patientUploadItem.vue?vue&type=script&lang=js&"
export * from "./patientUploadItem.vue?vue&type=script&lang=js&"
import style0 from "./patientUploadItem.vue?vue&type=style&index=0&id=63f359cd&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports